// Maps legacy ReadMe help-doc slugs to their new Crisp knowledge-base article URLs.
// The support.uplisting.io domain was repointed from ReadMe to Crisp, so the old
// `/docs/{slug}` URLs now 404. Crisp article URLs are per-article
// (`/en/article/{slug}-{id}/`) and cannot be derived from a slug, so the mapping is
// explicit. Generated from the ReadMe -> Crisp migration (migrate-readme-to-crisp.js).

export const HELP_ARTICLE_URLS: Record<string, string> = {
  'advanced-reporting':
    'https://support.uplisting.io/en/article/kick-start-guide-to-advanced-reporting-thuzov/',
  'an-introduction-to-reports':
    'https://support.uplisting.io/en/article/an-introduction-to-reports-shu3dn/',
  api: 'https://support.uplisting.io/en/article/api-webhooks-vzlowi/',
  'automated-guest-entry-using-smartlocks':
    'https://support.uplisting.io/en/article/automated-guest-access-with-remotelock-wrur1v/',
  'automated-reviews':
    'https://support.uplisting.io/en/article/automated-reviews-10tqsh6/',
  'beyond-pricing':
    'https://support.uplisting.io/en/article/beyond-pricing-xc4yxf/',
  'booking-site-markup':
    'https://support.uplisting.io/en/article/custom-booking-site-markup-f3ww1j/',
  'booking-sites':
    'https://support.uplisting.io/en/article/booking-sites-ap83vk/',
  'booking-windows':
    'https://support.uplisting.io/en/article/booking-windows-131opr/',
  bookings: 'https://support.uplisting.io/en/article/bookings-jbve5v/',
  'client-statements':
    'https://support.uplisting.io/en/article/client-statements-a96rg3/',
  'closed-for-arrival-departure':
    'https://support.uplisting.io/en/article/closed-for-arrival-cfa-departure-cfd-1e16h2m/',
  'connecting-to-airbnb':
    'https://support.uplisting.io/en/article/the-airbnb-connection-process-18uztpc/',
  'create-a-new-booking':
    'https://support.uplisting.io/en/article/create-a-new-booking-1topnsd/',
  'custom-property-attributes':
    'https://support.uplisting.io/en/article/custom-property-attribute-tags-dz27bs/',
  'custom-tags':
    'https://support.uplisting.io/en/article/custom-message-tags-78rd74/',
  dashboard: 'https://support.uplisting.io/en/article/dashboard-27fe7b/',
  'direct-promotions':
    'https://support.uplisting.io/en/article/promotions-1v9q9ed/',
  'enquiry-auto-responder':
    'https://support.uplisting.io/en/article/enquiry-auto-responder-ejy2pe/',
  'esign-rental-agreements':
    'https://support.uplisting.io/en/article/esign-rental-agreements-1mn28ug/',
  'extra-guest-charges':
    'https://support.uplisting.io/en/article/extra-guest-charges-gu0y0e/',
  'facebook-pixel':
    'https://support.uplisting.io/en/article/facebook-pixel-1mczq2g/',
  'google-tag-manager':
    'https://support.uplisting.io/en/article/installing-google-analytics-4-via-google-tag-manager-9z51yw/',
  'guest-identification-verification':
    'https://support.uplisting.io/en/article/guest-identification-verification-11gqur/',
  'guest-messages':
    'https://support.uplisting.io/en/article/guest-message-rules-169wtsu/',
  'how-to-activate-the-website-builder':
    'https://support.uplisting.io/en/article/how-to-activate-the-website-builder-rvrdy/',
  'how-to-connect-if-you-already-have-a-vrbo-account':
    'https://support.uplisting.io/en/article/how-to-connect-if-you-already-have-a-vrbo-account-gef1xp/',
  'how-to-connect-to-bookingcom':
    'https://support.uplisting.io/en/article/how-to-connect-to-bookingcom-legacy-13plfgr/',
  'how-to-connect-to-vrbo':
    'https://support.uplisting.io/en/article/how-to-connect-to-vrbo-1k7b4v2/',
  'how-to-get-listed-on-google-vacation-rentals':
    'https://support.uplisting.io/en/article/how-to-publish-your-properties-on-google-v6v4lh/',
  'how-to-link-listings':
    'https://support.uplisting.io/en/article/how-to-link-listings-1jkzsed/',
  'how-to-link-restrictions-to-all-rate-plans':
    'https://support.uplisting.io/en/article/how-to-link-restrictions-to-all-rate-plans-10ul1hn/',
  'how-to-set-and-change-rates-on-uplisting':
    'https://support.uplisting.io/en/article/how-to-set-and-change-rates-on-uplisting-9norvt/',
  'how-to-use-the-client-management-feature':
    'https://support.uplisting.io/en/article/how-to-use-the-client-management-feature-jkwa9a/',
  'insight-metric-calculations':
    'https://support.uplisting.io/en/article/metric-calculations-1xa3z3f/',
  intercom: 'https://support.uplisting.io/en/article/intercom-xcq5xt/',
  'introduction-to-automated-messages':
    'https://support.uplisting.io/en/article/introduction-to-automated-messages-2l1vfa/',
  'introduction-to-protect':
    'https://support.uplisting.io/en/article/introduction-to-protect-qx5qib/',
  'introduction-to-the-direct-booking-engine':
    'https://support.uplisting.io/en/article/introduction-to-the-direct-booking-engine-v7w0kq/',
  'introduction-to-uplisting-cleaning':
    'https://support.uplisting.io/en/article/introduction-to-the-cleaning-scheduler-1mmm2wf/',
  listings:
    'https://support.uplisting.io/en/article/properties-listings-1x5c9gr/',
  'management-fees':
    'https://support.uplisting.io/en/article/custom-management-fees-ekpf5a/',
  'mark-dates-unavailable':
    'https://support.uplisting.io/en/article/mark-individual-dates-unavailable-bpy12r/',
  'minimum-length-of-stay':
    'https://support.uplisting.io/en/article/minimum-length-of-stay-mlos-1iju0z9/',
  minut: 'https://support.uplisting.io/en/article/minut-hqfxw9/',
  'offline-security-deposits-for-airbnb':
    'https://support.uplisting.io/en/article/airbnb-offline-security-deposits-1ou0jc1/',
  'outbound-message-logs':
    'https://support.uplisting.io/en/article/outbound-message-logs-1mod5j/',
  'ownerclient-portal':
    'https://support.uplisting.io/en/article/client-owner-management-7da6b9/',
  'payment-rules-guest-payment-plans':
    'https://support.uplisting.io/en/article/payment-rules-guest-payment-plans-2be8n7/',
  'post-connection-checklist':
    'https://support.uplisting.io/en/article/airbnb-post-connection-checklist-1ck9qxn/',
  pricelabs: 'https://support.uplisting.io/en/article/pricelabs-17o3vvz/',
  'protect-security-deposits':
    'https://support.uplisting.io/en/article/protect-security-deposits-r3rx6a/',
  'rate-rules':
    'https://support.uplisting.io/en/article/lead-time-rate-rules-last-minute-discounts-1qkk10u/',
  'revenue-cost-attribution-settings':
    'https://support.uplisting.io/en/article/revenue-cost-attribution-settings-1dvju9q/',
  safely: 'https://support.uplisting.io/en/article/safely-49dm05/',
  'smart-rates':
    'https://support.uplisting.io/en/article/smart-rates-prices-1edml99/',
  'sms-messaging':
    'https://support.uplisting.io/en/article/sms-messages-6lahmw/',
  stripe: 'https://support.uplisting.io/en/article/stripe-wytbfs/',
  'syncing-prices-from-all-other-pricing-solutions':
    'https://support.uplisting.io/en/article/syncing-prices-from-all-other-pricing-solutions-16d1fpg/',
  tags: 'https://support.uplisting.io/en/article/tag-group-listings-rnb0oj/',
  'team-mates': 'https://support.uplisting.io/en/article/users-12i0zpm/',
  tripadvisor: 'https://support.uplisting.io/en/article/tripadvisor-k79irl/',
  'turn-off-instant-book':
    'https://support.uplisting.io/en/article/turn-off-instant-book-9m4myx/',
  turnoverbnb:
    'https://support.uplisting.io/en/article/turno-formerly-turnoverbnb-1gzn5bw/',
  'understanding-billing':
    'https://support.uplisting.io/en/article/understanding-billing-wphphp/',
  'unified-inbox':
    'https://support.uplisting.io/en/article/unified-inbox-1yy0esr/',
  wheelhouse: 'https://support.uplisting.io/en/article/wheelhouse-1bdu3mf/',
  zapier: 'https://support.uplisting.io/en/article/zapier-106c1mc/',
};

// Help-center home, used as a safe fallback for any unmapped slug.
export const HELP_CENTER_URL = 'https://support.uplisting.io';

export function helpArticleUrl(slug: string): string {
  return HELP_ARTICLE_URLS[slug] ?? HELP_CENTER_URL;
}
